<template>
<div>
  <div class="content">
    <div class="upload-box">
      <van-uploader v-model="fileList" :max-count="1" :max-size="10240 * 1024" @oversize="onOversize" :after-read="afterReadFile" :before-delete="deleteUploadImg">
      </van-uploader>
    </div>

    <div>
      <van-cell-group>
        <van-field v-model="xckphone" name="xckphone" label="行程卡手机号(可修改)" type="tel" value="{xckphone}" />
        <van-field v-model="xckrq" name="xckrq" label="行程卡日期" value="{xckrq}" readonly />
        <van-field v-model="xckcs" name="xckcs" label="行程卡途经城市" value="{xckcs}" type="textarea" rows="2" readonly />
      </van-cell-group>
    </div>

    <div style="padding: .875rem 0;margin:0 1rem;">
      <van-button :loading="uploadLoading" :disabled="uploadDisabled" round block type="info" class="addBtn" @click="uploadButton" loading-text="上传中...">
        保存
      </van-button>
    </div>
  </div>
  <Tabbar></Tabbar>
</div>
</template>

<script>
import api from '@/fetch/api';
import {
  Dialog,
  Toast
} from 'vant'
import Tabbar from '../Public/tabbarTpl.vue'
export default {
  components: {
    Tabbar
  },
  created() {
    document.title = "上传行程码";
  },
  data() {
    return {
      fileList: [],
      xckphone: '',
      xckrq: '',
      xckcs: '',
      xckurl:"",
      zhuangtai:0,
      uploadLoading: false,
      uploadDisabled: true
    };
  },

  methods: {
    onOversize() {
      Toast('文件大小不能超过 10Mb');
    },
    afterReadFile(file) {
      var that = this;
      that.$data.xckphone = "";
      that.$data.xckrq = "";
      that.$data.xckcs = "";
      that.$data.xckurl = "";

      var formData = new FormData();
      var openid = this.$store.state.wx_info.openid;
      formData.append('openid', openid);
      formData.append('uploadpics', file.file);
      api.postTravel(formData).then(function(resData) {
        var res = JSON.parse(resData);
        console.log('res.data',res.data);
        if (res.respCode == "0") {
          var travelState = res.data.zhuangtai;
          let csReplaceStr = '';//'(注:*表示当前该城市存在中风险或高风险地区，并不表示用户实际到访过这些中高风险地区。)';
          that.$data.uploadDisabled = true;

          switch (travelState) {
            case "0":
              that.$data.xckphone = res.data.xckphone.replace("的动态行程卡", "");
              that.$data.xckrq = res.data.xckrq;
              that.$data.xckcs = res.data.xckcs.replace(csReplaceStr, "");
              that.$data.xckurl = res.data.xckurl;
              that.$data.zhuangtai = travelState;
              that.$data.uploadDisabled = false;
              break;
            case "99":
              Dialog({
                message: '行程图片日期不是今天'
              });
              break;
            case "98":
              Dialog({
                message: '图片未识别'
              });
              break;
            case "97":
              Dialog({
                message: '途经中高风险地区'
              });
              break;
            case "96":
              Dialog({
                message: '手机号码与绑定用户手机号不一致'
              });
              break;
          }
        } else {
          Toast(res.message);
        }

      }).catch(function() {
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');
      });
    },
    deleteUploadImg(file, detail) {
      let index = detail.index;
      this.fileList.splice(index, 1)
    },
    uploadButton() {
      var that = this;
      var openid = that.$store.state.wx_info.openid;
      var xckphone = that.$data.xckphone;
      var xckrq = that.$data.xckrq;
      var xckcs = that.$data.xckcs;
      var xckurl = that.$data.xckurl;
      var zhuangtai = that.$data.zhuangtai;

      var data = JSON.stringify({
        openid: openid,
        xckphone:xckphone,
        xckrq:xckrq,
        xckcs:xckcs,
        xckurl:xckurl,
        zhuangtai:zhuangtai,
      });

      api.postTravelInfo(data).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == "0") {
          Dialog.alert({
            message: '上传成功',
          }).then(() => {
            that.$router.push({
              name: 'index',
            });
          });
        }
      }).catch(function() {
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');
      });

    }
  },
};
</script>
<style lang="scss" scoped>
.content {
    background: #fff;
    padding-top: 0.28rem;
    margin-top: 1rem;
    .addBtn {
        background: #316892;
    }
    .upload-box {
        margin-top: 1rem;
        margin-left: 1rem;
        .upload-box__title {
            padding: 1rem 0;
        }
    }
}
.preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
}
</style>
